import React from 'react';
import { Link } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard/ProfileCard';
import { teamData } from '../data/teamData';
import Button from '../components/Button/Button';
import '../App.css'; // Reutilizamos los estilos generales

const EquipoPage: React.FC = () => {
  return (
    <div className="section team-page">
      <h2 className="section-title">Nuestro Equipo</h2>
      <div className="team-grid">
        {teamData.map((member, index) => (
          <ProfileCard
            key={index}
            name={member.name}
            title={member.title}
            avatarUrl={member.avatarUrl}
            showUserInfo={false}
          />
        ))}
      </div>
      <div style={{ marginTop: '40px' }}>
        <Link to="/">
          <Button variant="primary">Volver al Inicio</Button>
        </Link>
      </div>
    </div>
  );
};

export default EquipoPage;